import type {RefObject} from "react";
import {useState} from "react";
import styled from "styled-components";
import {ClickToEditInputV5} from "../../input/clicktoedit/ClickToEditInputV5";
import {SelectInputStyled, SelectInputV5} from "../../input/select/SelectInputV5";
import type {Type} from "../../../../data/models/Type";
import {XyiconFeature} from "../../../../generated/api/base";
import {useAppStore} from "../../../../StateManager";
import {HorizontalAlignment, VerticalAlignment} from "../../../../utils/dom/DomUtils";
import {FieldV5} from "../../details/FieldV5";
import {CreatePopupFieldStyled} from "../../popup/CreatePopupField.styled";
import {CreatePopupStyled} from "../CreatePopupStyled";

interface IPortfolioCreatePopupV5Props {
	readonly onClose: () => void;
	readonly parentRef: RefObject<HTMLDivElement>;
}

export const PortfolioCreatePopupV5 = (props: IPortfolioCreatePopupV5Props) => {
	const appState = useAppStore((state) => state.appState);
	const [name, setName] = useState<string>("");
	const [selectedType, setSelectedType] = useState<Type>(null);
	const [createClicked, setCreateClicked] = useState<boolean>(false);

	const types = appState.types[XyiconFeature.Portfolio];
	const isFormValid = selectedType && selectedType.id && name && appState.actions.isPortfolioNameValid(name);

	const onCreateClicked = async () => {
		setCreateClicked(true);

		try {
			const models = await appState.app.transport.services.feature.create(
				{
					name: name,
					portfolioTypeID: selectedType.id,
				},
				XyiconFeature.Portfolio,
			);

			props.onClose(/* models?.[0]?.id */);
		} catch (error) {
			console.warn("error", error);
		}

		setCreateClicked(false);
	};

	const getErrorMessage = (value: string) => {
		return !value.trim() ? "Name cannot be empty!" : appState.actions.isPortfolioNameValid(name) ? "" : "Name needs to be unique!";
	};

	return (
		<CreatePopupStyled
			onClose={props.onClose}
			label="Create Portfolio"
			parentRef={props.parentRef.current}
			buttonProps={{
				onClick: onCreateClicked,
				disabled: createClicked || !isFormValid,
				label: "Create",
			}}
			verticalAlignment={VerticalAlignment.bottomOuter}
			horizontalAlignment={HorizontalAlignment.right}
			isSmallPopup={true}
		>
			<CreatePopupFieldStyled>
				<StyledFieldV5
					label="Name"
					className="focused"
				>
					<ClickToEditInputV5
						value={name}
						onLiveChange={(name) => setName(name)}
						onChange={(name) => setName(name)}
						getErrorMessage={getErrorMessage}
						placeholder="Portfolio Name"
						className="portfolionameInput"
					/>
				</StyledFieldV5>
				<StyledFieldV5
					label="Type"
					className="focused"
				>
					<SelectInputV5
						options={types}
						renderOptionWhenClosed={(type) => (type ? type.name : "")}
						selected={selectedType}
						onChange={(type) => setSelectedType(type)}
						fullWidth={true}
						placeholder="Type"
						isSameWidth={true}
					/>
				</StyledFieldV5>
			</CreatePopupFieldStyled>
		</CreatePopupStyled>
	);
};

const StyledFieldV5 = styled(FieldV5)`
	${SelectInputStyled} {
		svg {
			flex-shrink: 0;
		}
	}
`;
